export const NAV_FEATURES = [
  {
    key: "bot-trader",
    label: "Bot Trader",
    href: "/bot-trader",
    desc: "Follow paper trades from signal to fill",
    icon: "bot",
  },
  {
    key: "building-strategies",
    label: "Building Strategies",
    href: "/building-strategies",
    desc: "Define entry and exit rules without code",
    icon: "builder",
  },
  {
    key: "strategy-discovery",
    label: "Strategy Discovery",
    href: "/strategy-discovery",
    desc: "Search, compare, and refine candidate strategies",
    icon: "discovery",
  },
];

export const NAV_STRATEGY_WALLET_CLUSTER = [
  { key: "strategy-wallet-vs-backtesting", label: "Strategy Wallet vs Backtesting", href: "/strategy-wallet-vs-backtesting" },
  { key: "strategy-wallet-alerts", label: "Strategy Wallet Alerts", href: "/strategy-wallet-alerts" },
  { key: "strategy-wallet-app", label: "Strategy Wallet App", href: "/strategy-wallet-app" },
];

export const NAV_LEGACY_PRODUCT_PATHS = [
  "/backtesting-wallet",
  "/strategy-wallet",
  "/strategy-alerts",
  "/backtesting-app",
  "/backtesting-results",
];

export const NAV_ABOUT = [
  { key: "about", label: "About Stratify", href: "/about" },
  { key: "justen-chartrand", label: "Justen Chartrand", href: "/about/justen-chartrand" },
  { key: "marco-schapira", label: "Marco Schapira", href: "/about/marco-schapira" },
];

export const NAV_LEGAL = [
  { key: "support", label: "Support", href: "/support" },
  { key: "privacy-policy", label: "Privacy Policy", href: "/privacy-policy" },
  { key: "terms-of-use", label: "Terms of Use", href: "/terms-of-use" },
  { key: "refund-policy", label: "Refund Policy", href: "/refund-policy" },
  { key: "subscription-terms", label: "Subscription Terms", href: "/subscription-terms" },
];

export const NAV_FOOTER_COMPANY = [
  { key: "pricing", label: "Pricing", href: "/pricing" },
  { key: "about", label: "About", href: "/about" },
  { key: "support", label: "Support", href: "/support" },
];

export const NAV_FOOTER_PRODUCT = [
  ...NAV_FEATURES.map((item) => ({
    key: item.key,
    label: item.label,
    href: item.href,
  })),
  { key: "integrations", label: "Integrations", href: "/integrations" },
];

export const NAV_ITEMS = [
  {
    key: "connect-brokerage",
    label: "How to connect your brokerage account",
    href: "/connect-brokerage",
  },
  { key: "pricing", label: "Pricing", href: "/pricing" },
  { key: "support", label: "Support", href: "/support" },
];
